import { safeApiRequest } from './apiClient';

// --- Admin: personel durum çizelgesi ---
export const fetchPersonelDurumlari = (tarih) =>
  safeApiRequest('/api/santral/personel-durumlari', {
    method: 'GET',
    query: tarih ? { tarih } : undefined,
  });

export const fetchAtanabilirKullanicilar = () =>
  safeApiRequest('/api/santral/atanabilir-kullanicilar', { method: 'GET' });

// --- Admin: dahili yönetimi ---
export const fetchDahililer = () =>
  safeApiRequest('/api/santral/dahililer', { method: 'GET' });

export const createDahili = (body) =>
  safeApiRequest('/api/santral/dahililer', { method: 'POST', body });

export const updateDahili = (id, body) =>
  safeApiRequest(`/api/santral/dahililer/${encodeURIComponent(id)}`, { method: 'PUT', body });

export const deleteDahili = (id) =>
  safeApiRequest(`/api/santral/dahililer/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const ataDahili = (id, kullaniciId) =>
  safeApiRequest(`/api/santral/dahililer/${encodeURIComponent(id)}/ata`, {
    method: 'POST',
    body: { kullaniciId: kullaniciId || null },
  });

// --- Admin: kuyruk yönetimi ---
export const fetchKuyruklar = () =>
  safeApiRequest('/api/santral/kuyruklar', { method: 'GET' });

export const createKuyruk = (body) =>
  safeApiRequest('/api/santral/kuyruklar', { method: 'POST', body });

export const updateKuyruk = (id, body) =>
  safeApiRequest(`/api/santral/kuyruklar/${encodeURIComponent(id)}`, { method: 'PUT', body });

export const deleteKuyruk = (id) =>
  safeApiRequest(`/api/santral/kuyruklar/${encodeURIComponent(id)}`, { method: 'DELETE' });

// --- Panel: kuyruk üstlenme ---
export const kuyrukUstlen = (queue) =>
  safeApiRequest('/api/santral/kuyruk/ustlen', { method: 'POST', body: { queue } });

export const kuyrukBirak = (queue) =>
  safeApiRequest('/api/santral/kuyruk/birak', { method: 'POST', body: { queue } });

/** Panel açılışında üstlenebilir kuyruklardaki takılı geçici üyelikleri temizler */
export const geciciKuyruklariTemizle = () =>
  safeApiRequest('/api/santral/kuyruk/temizle-gecici', { method: 'POST', body: {} });

/** Netgsm hangup — arayanın çağrısını tamamen sonlandırır */
export const cagriSonlandir = (uniqueId) =>
  safeApiRequest('/api/santral/cagri/sonlandir', {
    method: 'POST',
    body: { unique_id: uniqueId },
  });

/** Telefon listesine göre kayıtlı müşteri ad-soyad (0 / +90 uyumlu) */
export const musteriTelefonToplu = (telefonlar) =>
  safeApiRequest('/api/santral/musteri-telefon', {
    method: 'POST',
    body: { telefonlar },
  });

/** Netgsm CDR — gelen çağrılar (cevaplanan + cevapsız) */
export const fetchGelenCagrilar = (params = {}) =>
  safeApiRequest('/api/santral/gelen-cagrilar', {
    method: 'GET',
    query: params,
  });

/** Netgsm CDR — giden çağrılar (cevaplanan + cevapsız) */
export const fetchGidenCagrilar = (params = {}) =>
  safeApiRequest('/api/santral/giden-cagrilar', {
    method: 'GET',
    query: params,
  });

/** Çağrı merkezi istatistikleri (bugün / önceki mesai dışı / aylık / saatlik) */
export const fetchCagriIstatistik = (params = {}) =>
  safeApiRequest('/api/santral/cagri-istatistik', {
    method: 'GET',
    query: params,
  });
